import React from 'react'
import styled from 'styled-components'
import Responsive from '../../assets/config/Responsive'
// @ts-ignore
import WelcomeBannerBgTablet from '../../assets/img/business-welcome-banner-tablet-office.svg'
// @ts-ignore
import WelcomeBannerBgMobile from '../../assets/img/business-welcome-banner-mobile-office.svg'
import Colors from '../../assets/styles/Colors'
import { useNavigate } from 'react-router-dom'
import ServiceCard from '../../components/ServiceCard'
import AutoplayCarousel from '../../components/AutoplayCarousel'
import { useDispatch } from 'react-redux'
import { SliceType, clearCompanyInfo, setProductType } from '../../store/businessSlice'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import carIcon from '../../assets/img/business-icons/carIcon.svg'
// @ts-ignore
import healthIcon from '../../assets/img/business-icons/healthIcon.svg'
// @ts-ignore
import propertyIcon from '../../assets/img/business-icons/propertyIcon.svg'
// @ts-ignore
import otherIcon from '../../assets/img/business-icons/otherIcon.svg'
import { useAppSelector } from '../../store'

const BusinessLanding = () => {
  //
  const navigate = useNavigate()
  //
  const dispatch = useDispatch()
  //
  const { t } = useTranslation()
  //
  const { productType } = useAppSelector((data: { business: SliceType }) => data.business)
  // product categories object
  const productCategories = [
    {
      productType: 'health',
      title: `${t('healthInsurance')}`,
      body: `${t('healthBusinessDescription')}`,
      image: `${healthIcon}`,
    },
    {
      productType: 'car',
      title: `${t('carInsurance')}`,
      body: `${t('carBusinessDescription')}`,
      image: `${carIcon}`,
    },
    {
      productType: 'property',
      title: `${t('propertyInsurance')}`,
      body: `${t('propertyBusinessDescription')}`,
      image: `${propertyIcon}`,
    },
    {
      productType: 'other',
      title: `${t('other')}`,
      body: `${t('otherBusinessDescription')}`,
      image: `${otherIcon}`,
    },
  ]

  return (
    <>
      <WelcomeSection>
        <WelcomeBlock>
          <h1>{t('forYourBusiness')}</h1>
          <p>{t('franiHelpsYourBusiness')}</p>
          <button type="button" onClick={() => navigate(`/business-category`)}>
            {t('getOffer')}
          </button>
          <BackgroundImage src={WelcomeBannerBgMobile} alt="welcome-banner-office" />
        </WelcomeBlock>
      </WelcomeSection>

      <ServiceSection>
        <ServiceHead>
          <h1>{t('insuranceProducts')}</h1>
          <p>{t('selectInsuranceBusiness')}</p>
        </ServiceHead>
        <Service>
          {productCategories &&
            productCategories.map((item, index) => {
              return (
                <ServiceCard
                  key={index}
                  to={
                    item.productType === 'health'
                      ? '/health-company-info'
                      : item.productType === 'car'
                      ? '/car-company-info'
                      : item.productType === 'property'
                      ? '/property-company-info'
                      : item.productType === 'other'
                      ? '/other-company-info'
                      : '/business-category'
                  }
                  onClick={() => [
                    item.productType !== productType && dispatch(setProductType(item.productType)),
                    item.productType !== productType && dispatch(clearCompanyInfo()),
                  ]}
                  bottomText={t('requestOffer')}
                  disabled={false}
                  hideMinPrice={true}
                  img={item.image}
                  itemTitle={item.title}
                  itemBody={item.body}
                  itemType={item.productType}
                  arrow={true}
                />
              )
            })}
        </Service>
      </ServiceSection>

      <AutoplayCarousel />
    </>
  )
}

export default BusinessLanding

const WelcomeSection = styled.section`
  background-image: url(${WelcomeBannerBgTablet});
  height: calc(100vh - 100px);
  object-fit: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: 100vw auto;
  background-position-y: 75%;
  ${Responsive.laptop} {
    background-size: 100vw auto;
    background-image: url(${WelcomeBannerBgTablet});
  }
  ${Responsive.tablet} {
    background-size: 100vw auto;
    background-image: url(${WelcomeBannerBgTablet});
    background-position-y: 80%;
  }
  ${Responsive.mobile} {
    height: min-content;
    background-image: none;
  }
`
//
const BackgroundImage = styled.img`
  display: none;
  ${Responsive.mobile} {
    display: block;
    margin-top: 30px;
    margin-bottom: 70px;
  }
  @media (max-width: 400px) {
    width: 100%;
  }
`

const WelcomeBlock = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 90px;
  /* welcome banner titile */
  h1 {
    width: 600px;
    font-size: 48px;
    color: ${Colors.primaryBlack};
    line-height: 65px;
    text-align: center;
    font-weight: bold;
  }
  /* welcome banner description */
  p {
    margin-top: 25px;
    width: 600px;
    line-height: 30px;
    font-size: 22px;
    color: ${Colors.nevadaGrey};
    text-align: center;
  }
  /* welcome banner button */
  button {
    width: 260px;
    height: 64px;
    min-height: 64px;
    border-radius: 4px;
    background-color: ${Colors.primaryRed};
    outline: none;
    border: 0px;
    color: ${Colors.white};
    font-size: 18px;
    margin-top: 50px;
    transition: all 200ms ease-in;
    box-shadow: 0px 6px 20px rgba(254, 95, 85, 0.3);
    &:hover {
      transition: all 200ms ease-in;
      transform: scale(1.12);
      background-color: transparent;
      color: ${Colors.primaryBlack};
      border: 1px solid ${Colors.primaryBlack};
      box-shadow: none;
    }
  }

  ${Responsive.mobile} {
    padding-top: 35px;
    /* welcome banner titile */
    h1 {
      width: 300px;
      font-size: 24px;
      line-height: 35px;
    }
    /* welcome baaner description */
    p {
      width: 300px;
      margin-top: 5px;
      font-size: 14px;
      line-height: 20px;
    }
    /* welcome banner button */
    button {
      width: 220px;
      height: 48px;
      min-height: 48px;
      font-size: 14px;
      margin-top: 20px;
    }
  }
`
//
const ServiceSection = styled.section`
  background-color: ${Colors.backgroundGrey};
  padding-top: 85px;
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${Responsive.mobile} {
    padding-top: 0;
    padding-bottom: 40px;
  }
`

const Service = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 25px;
  justify-items: center;
  ${Responsive.tablet} {
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 25px;
  }
  ${Responsive.mobile} {
    grid-template-columns: repeat(auto-fit, minmax(250px, 330px));
    gap: 20px;
    width: unset;
  }
`
const ServiceHead = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 60px;
  /* TItle */
  h1 {
    font-size: 36px;
    /* font-size: 20px; */
    color: ${Colors.primaryBlack};
    margin-bottom: 25px;
    text-align: center;
    font-weight: bold;
  }
  /* description */
  p {
    font-size: 18px;
    color: ${Colors.nevadaGrey};
    width: 700px;
    text-align: center;
  }
  ${Responsive.mobile} {
    margin-bottom: 25px;
    padding-top: 35px;
    /* TItle */
    h1 {
      font-size: 18px;
      margin-bottom: 12px;
    }
    /* description */
    p {
      font-size: 12px;
      width: 335px;
    }
  }
`
